module.exports = __webpack_public_path__ + "static/img/aj1_jkfa_icon.png";